import { render, staticRenderFns } from "./soilInfoWidget.vue?vue&type=template&id=1ca37f53&scoped=true"
import script from "./soilInfoWidget.vue?vue&type=script&lang=js"
export * from "./soilInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./soilInfoWidget.vue?vue&type=style&index=0&id=1ca37f53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca37f53",
  null
  
)

export default component.exports